import clsx from "clsx";
import { Icon } from "../../../../components";
import { PropsWithTestId } from "../../../../components/@types";
import styles from "./common.module.scss";

type NavigationButtonProps = {
  disabled?: boolean;
  icon: "chevron-right" | "chevron-left";
  onClick: () => void;
};

const TableHeaderNavigationButton = ({
  "data-testid": dataTestId,
  disabled,
  icon,
  onClick
}: PropsWithTestId<NavigationButtonProps>) => (
  <Icon
    data-testid={dataTestId}
    className={clsx(styles.navigation_button, disabled && styles.disabled)}
    name={icon}
    size={12}
    onClick={onClick}
  />
);

export default TableHeaderNavigationButton;
